// **Author:** Selvadurai
import {
  Container,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import AddBeneficiaryModal from "./AddBeneficiaryModal";

export default function Beneficiaries() {
  const [beneficiaries, setBeneficiaries] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    fetch("http://localhost:3001/beneficiaries")
      .then((res) => res.json())
      .then(setBeneficiaries)
      .catch(() => setBeneficiaries([]));
  }, []);

  const handleAddBeneficiary = async (data) => {
    // POST to json-server
    await fetch("http://localhost:3001/beneficiaries", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    // Refresh list
    fetch("http://localhost:3001/beneficiaries")
      .then((res) => res.json())
      .then(setBeneficiaries)
      .catch(() => setBeneficiaries([]));
  };

  return (
    <Container maxWidth="md" sx={{ mt: 6 }}>
      <Typography variant="h5" gutterBottom>
        Beneficiaries
      </Typography>
      <Button variant="contained" color="primary" sx={{ mb: 2 }} onClick={() => setModalOpen(true)}>
        Add Beneficiary
      </Button>
      <AddBeneficiaryModal open={modalOpen} onClose={() => setModalOpen(false)} onAdd={handleAddBeneficiary} />
      <TableContainer component={Paper} elevation={3}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <strong>Name</strong>
              </TableCell>
              <TableCell>
                <strong>Account No.</strong>
              </TableCell>
              <TableCell>
                <strong>Remarks</strong>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {beneficiaries.map((b, i) => (
              <TableRow key={i}>
                <TableCell>{b.name}</TableCell>
                <TableCell>{b.accountNumber}</TableCell>
                <TableCell>{b.remarks || ""}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
}
